import _ from 'lodash';
import React from 'react';

const OnboardingContext = React.createContext();

const mapper = d => {
  const selected = !!_.find(
    _.get(window, 'Livewire.currentUser.profile.assetClasses', []),
    id => id === d.id,
  );
  return { ...d, selected };
};

const toggler = (arr, id) => {
  arr.some(asset => {
    const match = asset.id === id;
    if (match) {
      asset.selected = !asset.selected;
    }
    return match;
  });
  return arr;
};

const move = (state, slug, direction) => {
  const from = [...state[direction === 'follow' ? 'productsAvailable' : 'productsFollowing']];
  const index = _.findIndex(from, { slug });
  if (index === -1) {
    return state;
  }
  const unsortedTarget = [...state[direction === 'follow' ? 'productsFollowing' : 'productsAvailable']];
  const item = from.splice(index, 1);
  unsortedTarget.unshift(item[0]);
  const target = direction === 'follow'
    ? unsortedTarget
    : _.orderBy(unsortedTarget, ['popularity'], ['desc']);

  return {
    ...state,
    productsAvailable: direction === 'follow' ? from : target,
    productsFollowing: direction === 'follow' ? target : from,
  };
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'setInvestorTypes':
      return { ...state, investorTypes: payload };
    case 'setAssetClasses':
      return { ...state, assetClasses: (payload || []).map(mapper) };
    case 'setProductsAvailable':
      return { ...state, productsAvailable: _.orderBy(payload, ['popularity'], ['desc']) };
    case 'setSelectedInvestorType':
      return { ...state, selectedInvestorType: payload };
    case 'toggleAssetClassesSelection':
      return { ...state, assetClasses: toggler(state.assetClasses, payload) };
    case 'setUnfollow':
      return move(state, payload, 'unfollow');
    case 'setFollow':
      return move(state, payload, 'follow');
    case 'setFilteredProducts':
      return { ...state, filteredProducts: payload };
    case 'setFollowedProducts':
      return { ...state, followedProducts: payload };
    default:
      throw new Error();
  }
};

const defaultState = {
  investorTypes: [],
  assetClasses: [],
  selectedInvestorType: null,
  productsAvailable: [],
  productsFollowing: [],
};

export default OnboardingContext;
export {
  reducer,
  defaultState,
};
